import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, Platform } from '@ionic/angular';
import { advertisement, ServiceService } from '../service.service';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';

@Component({
  selector: 'app-detallescourses',
  templateUrl: './detallescourses.page.html',
  styleUrls: ['./detallescourses.page.scss' , '../../assets/scss/styles.scss'],
})
export class DetallescoursesPage implements OnInit, AfterViewInit {

  courseid: string;
  titleName:string= "";
  datos: any;
  userName:string;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  @ViewChild('contentCenter') contentCenter: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    public services: ServiceService,
    private loadingController: LoadingController,
    private socialSharing: SocialSharing,
    private router: Router,
    private streamingMedia: StreamingMedia,
    private platform: Platform,
    private oneSignal: OneSignal
    
  ) { 

    //this.initializeApp();
    this.setupPush();
  }

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    this.bringCoursesInformation();
    this.userName = localStorage.getItem("completeName");
    //this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
    //this.oneSignal.endInit();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(6);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async scrollingAds(event:any) {
    let rows = Math.floor(Number(event.detail.scrollTop-this.advertisements.SizePage)/this.advertisements.SizeDivImage);
    let final = rows+this.advertisements.Rows;
    if(event.detail.scrollTop > this.advertisements.SizePage && rows>0 && final > this.advertisements.Displayed.length && this.advertisements.Displayed.length < this.advertisements.MediaBasico.length && event.detail.scrollTop < (this.contentCenter.nativeElement.clientHeight-this.advertisements.SizePage)){
      let displayedLength = this.advertisements.Displayed.length;
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,final);
      let disply = this.advertisements.Displayed.slice(displayedLength,this.advertisements.Displayed.length);
      this.services.postAdvertisementUser(this.advertisements.getRelAdsMetricsId(disply));
    }
  }

  ngAfterViewInit(){
    //this.oneSignal.sendTag("user_type","Cursos");
    //console.log("Tag enviado");
  }

  /*
  async initializeApp() {
    this.platform.ready().then(() => {
      /*
      if (this.platform.is('cordova')) {
        this.setupPush();
      }
      
      this.setupPush();
    });
  }
  */

  initializeApp() {
    this.platform.ready().then(() => {
      // Optional OneSignal code for iOS to prompt users later
      // Set your iOS Settings
      var iosSettings = {};
      iosSettings["kOSSettingsKeyAutoPrompt"] = false; // will not prompt users when start app 1st time
      iosSettings["kOSSettingsKeyInAppLaunchURL"] = false; // false opens safari with Launch URL
      // OneSignal Code start:
      // Enable to debug issues.
      window["plugins"].OneSignal.setLogLevel({logLevel: 4, visualLevel: 4});
      var notificationOpenedCallback = function(jsonData) {
        console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
        if (jsonData.notification.payload.additionalData != null) {
          console.log("Here we access addtional data");
          if (jsonData.notification.payload.additionalData.openURL != null) {
            console.log("Here we access the openURL sent in the notification data");

          }
        }
      };
      window["plugins"].OneSignal
        .startInit("ac5cca1e-1623-4144-95c2-b481605564ea")
        .iOSSettings(iosSettings) // only needed if added Optional OneSignal code for iOS above
        .inFocusDisplaying(window["plugins"].OneSignal.OSInFocusDisplayOption.Notification)
        .handleNotificationOpened(notificationOpenedCallback)
        .endInit();
        
    });
  }

  setupPush() {
    // I recommend to put these into your environment.ts
    this.oneSignal.startInit('ac5cca1e-1623-4144-95c2-b481605564ea','576684940504');
 
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
 
    // Notifcation was received in general
    this.oneSignal.handleNotificationReceived().subscribe(data => {
      let msg = data.payload.body;
      let title = data.payload.title;
      let additionalData = data.payload.additionalData;
      //this.showAlert(title, msg, additionalData.task);
    });
 
    // Notification was really clicked/opened
    this.oneSignal.handleNotificationOpened().subscribe(data => {
      // Just a note that the data is a different place here!
      let additionalData = data.notification.payload.additionalData;
 
      //this.showAlert('Notification opened', 'You already read this before', additionalData.task);
    });

    this.oneSignal.sendTag("user_type","Cursos");
    this.oneSignal.setLogLevel({logLevel: 6, visualLevel: 0});
    

    //window["plugins"].OneSignal.sendTag("user_type","Cursos");
    console.log("Tag enviado");

    this.oneSignal.endInit();
  }

  async bringCoursesInformation(){
    this.courseid = this.activatedRoute.snapshot.paramMap.get('id');
    switch (Number(this.courseid)) {
      case 1:
        this.titleName = "Promociones";
        break;
      case 2:
        this.titleName = "Tutoriales y webinars";
        break;
      case 3:
        this.titleName = "Cursos presenciales";
        break;
      case 4:
        this.titleName = "Arranque de viruta";
        break;
      case 5:
        this.titleName = "Transformación de lámina";
        break;
      case 6:
        this.titleName = "Inyección de plásticos";
        break;
      case 7:
        this.titleName = "Otros";
        break;
      case 8:
        this.titleName = "Webinars";
        break;
      case 9:
        this.titleName = "Gratuito";
        break;
      default:
        break;
    }
    const loading = await this.loadingController.create({
      message: 'Cargando...',
      duration: 3000,
    });

    loading.present();


    this.services.getCoursesDetails(this.courseid).then(
      (data : any ) => {
        console.log("data", data);
        this.loadingController.dismiss();
        if(data != null){
          this.datos = data;
        }else{
          this.datos = new Array();
        }
        
        // console.log("this.course", this.course);
      }).catch( (error : any ) => {

        this.loadingController.dismiss();
        console.log(error);
      });
  }

  public isBrowserOrEmail(item : any ){
    if(item.url != null && String(item.url) != ""){
      this.askViaUrl(item);
      return;
    }
    else if(item.email != null && String(item.email) != ""){
      //Pedir info via correo.
      this.askViaEmail(item);
    }else{
      this.services.showAlert('No hay información disponible por el momento.');
    }
  }

  public askViaEmail(email : any ){
    // Share via email
    this.socialSharing.shareViaEmail(String(email.mailBody), String(email.mailAffair), [String(email.email)]).then(() => {
      // Success!
    }).catch(() => {
      // Error!
      this.services.showAlert('Ha ocurrido un error al intentar solicitar la info, reintente.');
    });
  }

  onImageOrGifError(event : any ){
     event.src = 'assets/images/imgNotFound.jpeg'
  }

  public gotoDetail(id:number){
    this.router.navigate(['/courseDetail', id]);
  }

  public askViaUrl(item: any){
    //window.open(String(item.url), '_system', 'location=yes');
    this.openFrame(String(item.url));
  }

  public openFrame(url : any ){

    if (this.platform.is('ios')) {
      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('id', 'ifrm'); // assign an id
  
      // to place before another page element
      var el = document.getElementById('iframeHolder');
      el.parentNode.insertBefore(ifrm, el);
  
      // assign url
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('width', '0px');
      ifrm.setAttribute('height', '0px');
    } else {
      window.open(url, '_system', 'location=yes')
    }


  }

  //Para abrir el video en mobile

  autoPlay(urlVideo: any) {
    console.log(urlVideo);
    
    const options: StreamingVideoOptions = {
      successCallback: () => { console.log('Video played'); },
      errorCallback: (e) => { console.log('Error streaming'); },
      orientation: 'landscape',
      shouldAutoClose: true,
      controls: true
    };

    this.streamingMedia.playVideo(String(urlVideo), options);
  }

  public showElement(dataElement : any ) {
    let show = false;
    if(dataElement) show = true;
    return show;
  }

  public isNumber(text:string){
    if(text){
      return !!text.match(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/);
    }
    return false;
  }

}
